import React from 'react';
import { Text, TextVariant } from '@naf/text';
import { Grid, GridCol } from '@naf-simba/building-blocks-grid';
import { ExternalLinkType } from '@appTypes/externalLinkType';
import { InternalLinkType } from '@appTypes/internalLinkType';
import { ExternalLinkCard } from './ExternalLinkCard/ExternalLinkCard';
import { InternalLinkCard } from './InternalLinkCard/InternalLinkCard';
import * as S from './Shortcuts.styles';

interface ShortcutsBlockProps {
  node?: ShortcutsProps;
}

export interface ShortcutsProps {
  key: string;
  shortcutList: (
    | { data: ExternalLinkType; type: 'externalLink'; key: string }
    | { data: InternalLinkType; type: 'internalLink'; key: string }
  )[];
  type: 'shortcuts';
  hideTitle?: boolean;
}

const ShortcutCard = ({ shortcut }: { shortcut: ShortcutsProps['shortcutList'][number] }) => {
  switch (shortcut.type) {
    case 'externalLink':
      return <ExternalLinkCard externalLink={shortcut.data} />;
    case 'internalLink':
      return <InternalLinkCard internalLink={shortcut.data} />;
    default:
      return null;
  }
};

export const Shortcuts = ({ node: { shortcutList, hideTitle } }: ShortcutsBlockProps) => (
  <S.ShortcutsContainer>
    {hideTitle ? null : <Text variant={TextVariant.Header2}>Populære tjenester fra NAF</Text>}
    <Grid>
      {shortcutList?.map((shortcut) => (
        <GridCol s="12" m="6" l="6" xl="4" key={shortcut.key}>
          <ShortcutCard shortcut={shortcut} />
        </GridCol>
      ))}
    </Grid>
  </S.ShortcutsContainer>
);
